import { useState } from "react";
import Pagination from "../../../../../components/web/Pagination";
import { useWalletContext } from "../../hooks/wallet-context";
import {
  WalletHistoryContentsWrapper,
  WalletHistoryListWrapper,
  WalletHistoryWrapper,
} from "./style";
import WalletHistoryItem from "./components/history-item";
import WalletHistorySkeleton from "./skeleton";
import { WalletNoData } from "../../style";

const WalletHistory = () => {
  const {
    historyList,
    totalPages,
    currentPage,
    setCurrentPage,
    historyloading,
  } = useWalletContext();
  const [selectedId, setSelectedId] = useState(-1);

  if (historyloading)
    return (
      <WalletHistoryWrapper>
        <WalletHistoryContentsWrapper>
          <div className="title">히스토리</div>
          <WalletHistorySkeleton />
        </WalletHistoryContentsWrapper>
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={setCurrentPage}
        />
      </WalletHistoryWrapper>
    );

  return (
    <WalletHistoryWrapper>
      {historyList.length !== 0 ? (
        <WalletHistoryContentsWrapper>
          <div className="title">히스토리</div>
          <WalletHistoryListWrapper>
            {historyList.map((item, index) => (
              <WalletHistoryItem
                key={index}
                item={item}
                isSelected={item.id === selectedId}
                setSelectedId={setSelectedId}
              />
            ))}
          </WalletHistoryListWrapper>
        </WalletHistoryContentsWrapper>
      ) : (
        <WalletNoData>참여한 게임이 없습니다. </WalletNoData>
      )}
      {totalPages > 1 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={setCurrentPage}
        />
      )}
    </WalletHistoryWrapper>
  );
};

export default WalletHistory;
